import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-pos-logo",
    templateUrl: "./pos-logo.component.html",
    styleUrls: ["./pos-logo.component.scss"]
})
export class FUIPOSLogoComponent {
    @Input() type: "chewzie" | "fedelta" = "fedelta";

    constructor() {}
}
